/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Progress from './Progress/index'
import React from 'react'
import Reporting from './Reporting/index'
import Status from './Status/index'
import TreatmentPlanName from './TreatmentPlanName/index'
import TreatmentPlanStatus from './TreatmentPlanStatus/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TreatmentPlanName
  viewPath={`${viewPath}/TreatmentPlanName`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Status
  viewPath={`${viewPath}/Status`}
/>
<TreatmentPlanStatus
  viewPath={`${viewPath}/TreatmentPlanStatus`}
/>
</div>
<Progress
  viewPath={`${viewPath}/Progress`}
/>
</div>
<Reporting
  viewPath={`${viewPath}/Reporting`}
/>
{children}
</React.Fragment>)
}